import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { RESTAURANT } from "@/data/restaurant";

const STORAGE_KEY = "meritz_promo_dismissed_v1";

export default function PromoBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY) !== "1") {
      setOpen(true);
    }
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      data-testid="promo-banner"
      role="status"
      className="relative z-50 bg-gradient-to-r from-[#F2B441] via-[#E89B26] to-[#F2B441] text-[#2C2825]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#2C2825] text-[#F2B441] shrink-0">
          <Sparkles size={14} />
        </span>
        <p className="text-sm sm:text-base font-semibold leading-tight">
          <span data-testid="promo-headline" className="font-display font-extrabold">
            🎉 {RESTAURANT.promo.headline}
          </span>
          <span className="hidden sm:inline ml-2 font-medium opacity-80">
            — {RESTAURANT.promo.sub}
          </span>
        </p>
        <button
          onClick={dismiss}
          aria-label="Dismiss promo"
          data-testid="promo-dismiss"
          className="ml-auto w-7 h-7 rounded-full bg-[#2C2825]/15 hover:bg-[#2C2825]/30 grid place-items-center transition-colors shrink-0"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
